import React, {useCallback} from 'react';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import Tab from '../../../../../elements/Tabs/Tab';
import {isMyContactsFilterTabActive} from './isMyContactsFilterTabActive';
import {useDispatch} from 'react-redux';

const CONTACTS_FILTER = {
    contacts: true,
};

function MyContacts(props) {
    const {className = '', eventId, filterParams} = props,
        i18n = useI18n(),
        selected = isMyContactsFilterTabActive(filterParams),
        dispatch = useDispatch();

    const handleClick = useCallback(() => {
        dispatch(app.actions.participants.setFilterParams(eventId, CONTACTS_FILTER));
    }, [eventId]);

    return (
        <Tab className={className} selected={selected} onClick={handleClick}>
            {i18n['label.tab.my_contacts']}
        </Tab>
    );
}

export default MyContacts;
